// extracted by mini-css-extract-plugin
export default {"wrapper":"tips_wrapper__dDmHs","content":"tips_content__fcbcV","subtitle":"tips_subtitle__a5V8i","subheader":"tips_subheader__yyApK"};